class ProductPersonalize {
	button = null;
	container = null;
	fields = {};
	opt = null;
	paid = false;
	personalize = false;
	section = '';
	variants = [];

	constructor(sid) {
		this.section = document.querySelector(`[id*="${sid}"]`);
		this.container = this.section.querySelector('.product-personalize');
		if (this.container === null) {
			return;
		}

		this.opt = JSON.parse(this.container.dataset.opt);
		this.paid = JSON.parse(this.container.dataset.paid);
		this.personalize = JSON.parse(this.container.dataset.personalize);

		if (this.personalize === false) {
			return;
		}

		this.variants = JSON.parse(this.container.nextElementSibling.innerHTML);

		this.fields = {
			option: this.container.querySelector('[name="option"]'),
			format: this.container.querySelector('[name="format"]'),
			str: this.container.querySelector('[name="str"]'),
			color: this.container.querySelector('[name="color"]'),
			embroidery: this.container.querySelector('[name="embroidery"]'),
			pattern: this.container.querySelectorAll('[name="pattern"]'),
			select: this.container.querySelector('.select'),
		};

		this.fields.option.addEventListener('change', this.init.bind(this));
		if (this.fields.option.querySelectorAll('option').length > 1) {
			const submit = document.querySelector('[data-add-to-cart]');
			this.button = this.create('button', {
				className: submit.className,
				innerHTML: submit.innerHTML,
				type: 'button'
			});

			submit.classList.add('hide');
			submit.after(this.button);

			this.button.addEventListener('click', async () => {
				this.button.classList.add('btn--loading');

				if (this.fields.option.selectedIndex === 0) {
					submit.click();
					return;
				}

				const s = await this.submit();
				if (s === true) {
					submit.click();
				}
			});
		}

		if (this.paid === false) {
			return;
		}


		this.fields.embroidery.addEventListener('change', ({ target }) => {
			this.fields.select.classList.toggle('disabled', target.selectedIndex !== 1);
		});

		const patterns = this.container.querySelector('.patterns');
		this.fields.select.addEventListener('click', ({ target }) => {
			patterns.classList.remove('hide');
		});
		patterns.querySelector('button').addEventListener('click', () => {
			patterns.classList.add('hide');
		});

		for (const e of [...this.fields.pattern]) {
			e.addEventListener('change', () => {
				patterns.classList.add('hide');
				this.fields.select.innerText = e.value;
			});
		}

		document.addEventListener('keydown', ({ key }) => {
			if (key === 'Escape' || key === 'Esc') {
				patterns.classList.add('hide');
			}
		});
	}

	create(tagname, param = {}, parent = null) {
		const e = Object.assign(document.createElement(tagname), param);
		if (parent !== null) {
			parent.append(e);
		}
		return e;
	}

	init() {
		const { selectedIndex } = this.fields.option;

		const fieldsets = this.container.querySelectorAll('fieldset');
		for (const e of [...fieldsets]) {
			e.classList.add('hide');
		}
		if (selectedIndex > 0) {
			fieldsets[0].classList.remove('hide');
			fieldsets[selectedIndex].classList.remove('hide');
		}


		for (const e of [...this.container.querySelectorAll('[ data-toggle-option]')]) {
			e.classList.toggle('hide', !(e.dataset.toggleOption == selectedIndex));
		}
		if (selectedIndex === 0) {
			this.container.reset();
		}

		if (this.paid === false) {
			return;
		}

		const s = this.container.querySelector('.select');
		s.classList.add('disabled');
		s.innerText = '柄の種類を選択する';

		this.fields.color.selectedIndex = 0;
		this.fields.embroidery.selectedIndex = 0;
		this.fields.pattern[0].checked = true;
	}

	async submit() {
		const formdata = new FormData(this.container);
		const obj = Object.fromEntries(formdata.entries());

		if (this.validation(obj) === true) {
			return false;
		}

		const quantity = Number(this.section.querySelector('[name="quantity"]').value || 1);

		const items = [];
		if (this.fields.option.value == 1) {
			items.push({
				id: this.opt,
				properties: { _naire_flg: true },
				quantity: [...obj.str].length * quantity
			});
		}

		obj._naire = this.opt;

		if (this.fields.option.selectedIndex === 2 && obj.pattern !== '') {
			const variant = this.variants.find(({ name }) => name === obj.pattern);
			if (variant) {
				items.push({
					id: Number(variant.id),
					properties: { _embroidery_flg: true },
					quantity: quantity
				});
			}
		}

		try {
			const res = await fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ items })
			});

			if (!res.ok) {
				throw new Error(`HTTP ${res.status}`);
			}
		} catch (err) {
			console.error(err);
		}

		const form = this.section.querySelector('[action="/cart/add"]');

		const checkField = (k, v) => {
			let e = form.querySelector(`[name="properties[${k}]"]`);
			if (e === null) {
				e = this.create('input', { name: `properties[${k}]`, type: 'hidden', }, form);
			}
			e.value = obj[v];
			return e;
		};

		checkField('オプション', 'option');
		checkField('表記', 'format');
		checkField('お名前', 'str');

		if (this.fields.option.selectedIndex === 2) {
			checkField('文字色', 'color');
			checkField('ワンポイント刺繍', 'embroidery');

			const embroidery = checkField('_embroidery', '_embroidery');
			const pattern = checkField('柄', 'pattern');
			if (this.fields.embroidery.selectedIndex === 0) {
				embroidery.remove();
				pattern.remove();
			}
		}

		return true;
	}

	unload() {
		this.container.reset();
		this.init();
	}

	validation(obj = {}) {
		try {
			const err = [];

			if (obj.format === '') {
				err.push('字体が選択されていません。');
			}
			if (obj.str === '') {
				err.push('お名前が入力されていません。');
			} else {
				if (
					(obj.format === 'ひらがな' && !new RegExp('^[\u3041-\u3096]+$').test(obj.str)) ||
					(obj.format === 'ローマ字の大文字' && !new RegExp('^[A-Z]+$').test(obj.str))
				) {
					err.push('お名前が指定された形式で入力されていません。');
				}
			}

			if (this.fields.option.selectedIndex === 2) {
				if (obj.color === '') {
					err.push('文字色が選択されていません。');
				}
				if (obj.embroidery === '必要' && obj.pattern === '') {
					err.push('柄の種類が選択されていません。');
				}
			}

			if (err.length > 0) {
				alert(err.join("\n"));
				this.button.classList.remove('btn--loading');
				return true;
			}

			return false;
		} catch (err) {
			return true;
		}
	}
};

class CartPersonalize {
	cart = {};
	naire = null;

	constructor(nid = null, pid = null) {
		this.naire = nid;
		this.refresh();
	}

	async refresh() {
		try {
			this.cart = await (await fetch('/cart.js')).json();

			if (this.cart.items.length === 0) {
				return;
			}

			let naire = {};
			let embroidery = {};

			let has_naire = false;
			let has_embroidery = false;

			for (const { key, properties, quantity, variant_title } of this.cart.items) {
				if (properties?._naire_flg === true) {
					naire[key] = quantity;
					has_naire = true;
				}
				if (properties?._embroidery_flg === true) {
					embroidery[key] = { quantity, variant_title };
					has_embroidery = true;
				}
			}

			if (has_naire === false && naire !== null) {
				const quantity = this.cart.items.reduce((sum, { properties, quantity }) => {
					if (properties?.['お名前'] && properties?.['オプション'].includes('有料')) {
						return sum + [...properties['お名前']].length * quantity
					}
					return sum;
				}, 0);

				if (quantity > 0) {
					const items = [{
						id: this.naire,
						properties: { _naire_flg: true },
						quantity
					}];
					await fetch('/cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({ items })
					});
					location.reload();
					return;
				}
			}

			if (has_naire === false && has_embroidery === false) {
				document.querySelector('.has_naire').classList.add('loaded');
				return;
			}

			const diff_naires = { ...naire };
			const diff_embroidery = structuredClone(embroidery);

			if (has_naire === true) {
				for (const [k, v] of Object.entries(naire)) {
					naire[k] = 0;
				}
			}
			if (has_embroidery === true) {
				for (const [k, v] of Object.entries(embroidery)) {
					embroidery[k].quantity = 0;
				}
			}

			for (const { properties, quantity } of this.cart.items) {
				if (properties?.['オプション'] === undefined) {
					continue;
				}

				if (has_naire === true && !properties?.['オプション'].includes('無料')) {
					naire[Object.keys(naire)[0]] += [...properties['お名前']].length * quantity;
				}
				if (has_embroidery === true) {

					const o = Object.values(embroidery).find(({ variant_title }) => variant_title === properties?.['柄']);
					if (o) {
						o.quantity += quantity;
					}
				}
			}

			const updates = {};
			if (has_naire === true) {
				for (const [k, v] of Object.entries(naire)) {
					if (diff_naires[k] !== v) {
						updates[k] = v;
					}
				}
			}
			if (has_embroidery === true) {
				for (const [k, { quantity }] of Object.entries(embroidery)) {
					if (diff_embroidery[k].quantity !== quantity) {
						updates[k] = quantity;
					}
				}
			}

			if (Object.keys(updates).length > 0) {
				await fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ updates })
				});
				location.reload();
			}

			document.querySelector('.has_naire').classList.add('loaded');
		} catch (err) {
			console.error(err);
		}

	}
};